import React, { useContext, useEffect } from 'react';
import { Button, IconButton, TextField, Typography, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { validateNonAlphanumeric } from '../../Utilities/helperFunctions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ThemeContext } from '../devices/AssociazioneMassiva';

/**
 * Opens a dialog to associate several devices to a task
 * 
 * React context is used here to share state with the embedded table elements
 * 
 * Standard props are still used whenever only one component is making use of that and/or there 
 * is no forecast of that value being required by other components in the future
 */
function AssociazioneMassivaHeader() {
    const {
        workRequestId, setWorkRequestId,
        filters, setFilters,
        taskError, showMessage,
        NMUQuantities,
        setEnableSorting,
        selected,
        isValidating, setIsValidating,
        rows, setRows,
        hasChanged,
        rowsRef,
        resetStateAndGetTask
    } = useContext(ThemeContext);
    // const workRequestIdRef = useRef();
    // rowsRef.current = workRequestId;

    const sortRowsForValidation = () => {
        let filteredRows = JSON.parse(JSON.stringify(rowsRef.current));
        let selectedRows = [];
        let newRows;

        for (let id of selected) {
            let row = filteredRows.find(row => row.device.id === id);
            row.loading = true;
            selectedRows.push({ ...row });
            const rowIndex = filteredRows.findIndex(row => row.device.id === id);
            filteredRows.splice(rowIndex, 1);
        }

        newRows = selectedRows.concat(filteredRows);
        setRows([...newRows]);
        setIsValidating(true);
        setEnableSorting(false);
    }

    const validateWorkRequestId = (value) => {
        let isValid = validateNonAlphanumeric(value);
        if (isValid) setWorkRequestId(value);
        else showMessage("Caratteri speciali non ammessi", "Warning")
    }

    const validateFilters = (label, value) => {
        let tempFilters = { ...filters };
        tempFilters[label] = value;
        setFilters(tempFilters);
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5em', margin: '0.5em', padding: '0.5em' }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <Box sx={{ width:'100%', marginTop: '1rem', display: 'inline-flex', padding: '1rem' }}>
                    <TextField
                        required={true}
                        error={taskError}
                        placeholder="Work Request ID"
                        inputProps={{ 'aria-label': 'search workrequestid' }}
                        helperText={taskError && taskError}
                        onChange={e => validateWorkRequestId(e.target.value)}
                        value={workRequestId}
                    />
                    <IconButton disabled={!workRequestId} aria-label="search" color="primary" onClick={() => resetStateAndGetTask(workRequestId)}>
                        <SearchIcon />
                    </IconButton>
                    {NMUQuantities && <Box sx={{ marginLeft: '1em' }}>
                        <Typography variant="body2">
                            Quantità per NMU:
                        </Typography>
                        <Typography variant="body2">
                            {NMUQuantities.map((el, i) => <span key={i} sx={{ marginRight: '0.5em' }}>({el.values.join(',')}) - {el.quantity}</span>)}
                        </Typography>
                    </Box>}
                    <Button
                        sx={{ marginLeft: 'auto' }}
                        variant="contained"
                        disabled={(rows?.length === 0 || !hasChanged || isValidating) ? true : false}
                        size="small"
                        onClick={sortRowsForValidation}
                        startIcon={<CheckCircleIcon />}
                    >
                        Convalida
                    </Button>
                </Box>
            </Box>
            {rows?.length > 0 && <Box sx={{ marginTop: '1em', display: 'flex' }}>
                <TextField
                    required={true}
                    error={taskError}
                    sx={{ width: 250 }}
                    placeholder="Serial Number TIM"
                    inputProps={{ 'aria-label': 'Serial Number TIM' }}
                    helperText={taskError && taskError}
                    onChange={e => validateFilters('serial_number_tim', e.target.value)}
                    value={filters?.serialNumberTim}
                />
                <TextField
                    required={true}
                    error={taskError}
                    sx={{ width: 150, marginLeft: '1em' }}
                    placeholder="COD NMU"
                    inputProps={{ 'aria-label': 'nmu' }}
                    helperText={taskError && taskError}
                    onChange={e => validateFilters('cod_nmu', e.target.value)}
                    value={filters?.serialNumberTim}
                />
                <TextField
                    required={true}
                    error={taskError}
                    sx={{ width: 150, marginLeft: '1em' }}
                    placeholder="Cod Sap Magazzino"
                    inputProps={{ 'aria-label': 'magazzino' }}
                    helperText={taskError && taskError}
                    onChange={e => validateFilters('cod_terr_sap', e.target.value)}
                    value={filters?.serialNumberTim}
                />
            </Box>
            }
        </Box>

    );
}

export default AssociazioneMassivaHeader;
